import CallLogModelBase from '../_generated/modelBases/call-log-model-base';

export default class CallLogModel extends CallLogModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
